// routes
import MoneyIcon from '@mui/icons-material/AttachMoney';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
// ----------------------------------------------------------------------

// Add at the top of the file temporarily
console.log('2026 paths check:', {
  excalibur2026: PATH_DASHBOARD.marketing.excalibur2026,
  excaliburltd2026: PATH_DASHBOARD.marketing.excaliburltd2026,
  catalina2026: PATH_DASHBOARD.marketing.catalina2026,
  // ... etc
});
const navConfig = [
  {
    subheader: 'General',
    items: [
      {
        title: 'Account',
        path: '',
        children: [
          {
            title: 'View Orders',
            path: PATH_DASHBOARD.account.boatorders,
            icon: <MoneyIcon />,
          },
          {
            title: 'View Invoices',
            path: PATH_DASHBOARD.account.dealerinvoices,
            icon: <MoneyIcon />,
          },
          {
            title: 'View Statement',
            path: PATH_DASHBOARD.account.viewstatement,
            icon: <MoneyIcon />,
          },
        ],
      },

      {
        title: 'Dealer Book',
        path: '',
        children: [
          { title: 'Boat Price Lists', path: PATH_DASHBOARD.boatpricelist },
          { title: 'Motor Price Lists', path: PATH_DASHBOARD.motorpricelist },
          { title: 'Option Price Lists', path: PATH_DASHBOARD.optionpricelist },
          { title: 'Spec Sheets', path: PATH_DASHBOARD.specsheets },
          { title: 'Co-Op', path: PATH_DASHBOARD.coop },
          { title: 'Important Info', path: PATH_DASHBOARD.importantinfo },
          {
            title: 'AT Toonshop',
            path: 'https://at-toonshop-dealer.com/password',
            target: '_blank',
            icon: <ArrowOutwardIcon />,
          },
          { title: 'Contact List', path: PATH_DASHBOARD.contactlist },
          { title: 'Floorplan Overview', path: PATH_DASHBOARD.floorplanoverview },
          // { title: 'Fusion Packages', path: PATH_DASHBOARD.fusionpackages },
          { title: 'Mission Statement', path: PATH_DASHBOARD.historymission },
          { title: 'Marketing Strategy', path: PATH_DASHBOARD.marketingstrategy },
          { title: 'In-store Marketing', path: PATH_DASHBOARD.instoremarketing },
          { title: 'New Owner Checklist', path: PATH_DASHBOARD.owneradvisorylist },
          { title: 'Online Dealer Resources', path: PATH_DASHBOARD.onlinedealerresources },
          { title: 'Wall Paint Codes', path: PATH_DASHBOARD.paintcodes },
          { title: 'Metal Jacket', path: PATH_DASHBOARD.metaljacket },
        ],
      },
      {
        title: 'Dealer Meeting',
        path: '',
        children: [
          {
            title: 'MY27 Dealer Meeting Presentation',
            path: PATH_DASHBOARD.dealermeeting.openhousepresentation,
          },
          { title: 'MY27 Dealer Meeting Boats', path: PATH_DASHBOARD.dealermeeting.openhouseboats },
        ],
      },
      {
        title: 'Marketing',
        path: '',
        children: [
          {
            title: 'Marketing Policy',
            path: PATH_DASHBOARD.marketing.marketingtools,
          },
          {
            title: 'Photos',
            path: PATH_DASHBOARD.marketing.photos,
            children: [
              {
                title: 'Model Year 2027',
                children: [
                  {
                    title: 'Avalon',
                    children: [
                      { title: 'Excalibur', path: PATH_DASHBOARD.marketing.excalibur2027 },
                      { title: 'Excalibur LTD', path: PATH_DASHBOARD.marketing.excaliburltd2027 },
                      { title: 'Catalina', path: PATH_DASHBOARD.marketing.catalina2027 },
                      { title: 'LSZ', path: PATH_DASHBOARD.marketing.lsz2027 },
                      { title: "Venture 8.5'W", path: PATH_DASHBOARD.marketing.venture852027 },
                      { title: "Venture 7.5'W/8'W", path: PATH_DASHBOARD.marketing.venture2027 },
                      // {
                      //   title: "Venture Promo 8.5'W",
                      //   path: PATH_DASHBOARD.marketing.venturepromo2027,
                      // },
                      { title: 'Avalon GEOfish', path: PATH_DASHBOARD.marketing.avalongeofish2027 },
                    ],
                  },
                  {
                    title: 'Tahoe',
                    children: [
                      { title: 'Grand Tahoe', path: PATH_DASHBOARD.marketing.grandtahoe2027 },
                      {
                        title: 'Grand Tahoe LTD',
                        path: PATH_DASHBOARD.marketing.grandtahoeltd2027,
                      },
                      { title: 'Cascade', path: PATH_DASHBOARD.marketing.cascade2027 },
                      { title: 'LTZ', path: PATH_DASHBOARD.marketing.ltz2027 },
                      { title: "Sport 8.5'W", path: PATH_DASHBOARD.marketing.sport852027 },
                      { title: "Sport 7.5'/8'W", path: PATH_DASHBOARD.marketing.sport2027 },
                      // { title: "Sport Promo 8.5'W", path: PATH_DASHBOARD.marketing.sportpromo2027 },
                      // { title: 'Tahoe GEOfish', path: PATH_DASHBOARD.marketing.tahoegeofish2027 },
                    ],
                  },
                  {
                    title: 'Aura',
                    path: PATH_DASHBOARD.marketing.aura2027,
                  },
                  {
                    title: 'Patriot Boat',
                    path: PATH_DASHBOARD.marketing.patriot,
                  },
                ],
              },
              {
                title: 'Model Year 2026',
                children: [
                  {
                    title: 'Avalon',
                    children: [
                      { title: 'Excalibur', path: PATH_DASHBOARD.marketing.excalibur2026 },
                      { title: 'Excalibur LTD', path: PATH_DASHBOARD.marketing.excaliburltd2026 },
                      { title: 'Catalina', path: PATH_DASHBOARD.marketing.catalina2026 },
                      { title: 'LSZ', path: PATH_DASHBOARD.marketing.lsz2026 },
                      { title: 'Venture 85', path: PATH_DASHBOARD.marketing.venture852026 },
                      { title: 'Venture', path: PATH_DASHBOARD.marketing.venture2026 },
                      { title: 'Avalon GEOfish', path: PATH_DASHBOARD.marketing.avalongeofish2026 },
                    ],
                  },
                  {
                    title: 'Tahoe',
                    children: [
                      { title: 'Grand Tahoe', path: PATH_DASHBOARD.marketing.grandtahoe2026 },
                      {
                        title: 'Grand Tahoe LTD',
                        path: PATH_DASHBOARD.marketing.grandtahoeltd2026,
                      },
                      { title: 'Cascade', path: PATH_DASHBOARD.marketing.cascade2026 },
                      { title: 'LTZ', path: PATH_DASHBOARD.marketing.ltz2026 },
                      { title: 'Sport 85', path: PATH_DASHBOARD.marketing.sport852026 },
                      { title: 'Sport', path: PATH_DASHBOARD.marketing.sport2026 },
                      { title: 'Tahoe GEOfish', path: PATH_DASHBOARD.marketing.tahoegeofish2026 },
                    ],
                  },
                  {
                    title: 'Aura',
                    children: [{ title: 'Aura', path: PATH_DASHBOARD.marketing.aura2026 }],
                  },
                ],
              },
              {
                title: 'Model Year 2025',
                children: [
                  {
                    title: 'Avalon',
                    children: [
                      { title: 'Excalibur', path: PATH_DASHBOARD.marketing.excalibur },
                      { title: 'Excalibur LTD', path: PATH_DASHBOARD.marketing.excaliburltd },
                      { title: 'Catalina', path: PATH_DASHBOARD.marketing.catalina },
                      { title: 'LSZ', path: PATH_DASHBOARD.marketing.lsz },
                      { title: 'Venture 85', path: PATH_DASHBOARD.marketing.venture85 },
                      { title: 'Venture', path: PATH_DASHBOARD.marketing.venture },
                      { title: 'Avalon GEOfish', path: PATH_DASHBOARD.marketing.avalongeofish },
                    ],
                  },
                  {
                    title: 'Tahoe',
                    children: [
                      { title: 'Grand Tahoe LTD', path: PATH_DASHBOARD.marketing.grandtahoeltd },
                      { title: 'Cascade', path: PATH_DASHBOARD.marketing.cascade },
                      { title: 'LTZ', path: PATH_DASHBOARD.marketing.ltz },
                      { title: 'Sport 85', path: PATH_DASHBOARD.marketing.sport85 },
                      { title: 'Sport', path: PATH_DASHBOARD.marketing.sport },
                      { title: 'Tahoe GEOfish', path: PATH_DASHBOARD.marketing.tahoegeofish },
                    ],
                  },
                  {
                    title: 'Aura',
                    children: [{ title: 'Aura', path: PATH_DASHBOARD.marketing.aura }],
                  },
                ],
              },
              {
                title: 'Model Year 2024',
                children: [
                  {
                    title: 'Avalon',
                    children: [
                      { title: 'Excalibur', path: PATH_DASHBOARD.marketing.excaliburarchive1 },
                      {
                        title: 'Excalibur LTD',
                        path: PATH_DASHBOARD.marketing.excaliburltdarchive1,
                      },
                      { title: 'Catalina', path: PATH_DASHBOARD.marketing.catalinaarchive1 },
                      { title: 'LSZ', path: PATH_DASHBOARD.marketing.lszarchive1 },
                      { title: 'Venture 85', path: PATH_DASHBOARD.marketing.venture85archive1 },
                      { title: 'Venture', path: PATH_DASHBOARD.marketing.venturearchive1 },
                      { title: 'VTX', path: PATH_DASHBOARD.marketing.vtxarchive1 },
                    ],
                  },
                  {
                    title: 'Tahoe',
                    children: [
                      { title: 'Grand Tahoe', path: PATH_DASHBOARD.marketing.grandtahoearchive1 },
                      {
                        title: 'Grand Tahoe LTD',
                        path: PATH_DASHBOARD.marketing.grandtahoeltdarchive1,
                      },
                      { title: 'Cascade', path: PATH_DASHBOARD.marketing.cascadearchive1 },
                      { title: 'LTZ', path: PATH_DASHBOARD.marketing.ltzarchive1 },
                      { title: 'Sport 85', path: PATH_DASHBOARD.marketing.sport85archive1 },
                      { title: 'Sport', path: PATH_DASHBOARD.marketing.sportarchive1 },
                      { title: 'SLT', path: PATH_DASHBOARD.marketing.sltarchive1 },
                    ],
                  },
                  {
                    title: 'Waketoon',
                    path: PATH_DASHBOARD.marketing.waketoonarchive1,
                  },
                ],
              },
              {
                title: 'Model Year 2023',
                children: [
                  {
                    title: 'Avalon',
                    children: [
                      { title: 'Excalibur', path: PATH_DASHBOARD.marketing.excaliburarchive },
                      {
                        title: 'Excalibur LTD',
                        path: PATH_DASHBOARD.marketing.excaliburltdarchive,
                      },
                      { title: 'Catalina', path: PATH_DASHBOARD.marketing.catalinaarchive },
                      { title: 'LSZ', path: PATH_DASHBOARD.marketing.lszarchive },
                      { title: 'Venture 85', path: PATH_DASHBOARD.marketing.venture85archive },
                      { title: 'Venture', path: PATH_DASHBOARD.marketing.venturearchive },
                      { title: 'VTX', path: PATH_DASHBOARD.marketing.vtxarchive },
                    ],
                  },
                  {
                    title: 'Tahoe',
                    children: [
                      { title: 'Grand Tahoe', path: PATH_DASHBOARD.marketing.grandtahoearchive },
                      {
                        title: 'Grand Tahoe LTD',
                        path: PATH_DASHBOARD.marketing.grandtahoeltdarchive,
                      },
                      { title: 'Cascade', path: PATH_DASHBOARD.marketing.cascadearchive },
                      { title: 'LTZ', path: PATH_DASHBOARD.marketing.ltzarchive },
                      { title: 'Sport 85', path: PATH_DASHBOARD.marketing.sport85archive },
                      { title: 'Sport', path: PATH_DASHBOARD.marketing.sportarchive },
                      { title: 'SLT', path: PATH_DASHBOARD.marketing.sltarchive },
                      { title: 'Waketoon', path: PATH_DASHBOARD.marketing.waketoonarchive },
                    ],
                  },
                ],
              },
            ],
          },

          {
            title: 'Videos',
            children: [
              { title: 'Avalon', path: PATH_DASHBOARD.marketing.avalonvideos },
              { title: 'Tahoe', path: PATH_DASHBOARD.marketing.tahoevideos },
            ],
          },
          {
            title: 'Logos & Brochures',

            children: [
              { title: 'Avalon', path: PATH_DASHBOARD.marketing.avalonbrochures },
              { title: 'Tahoe', path: PATH_DASHBOARD.marketing.tahoebrochures },
            ],
          },

          // {
          //   title: 'Social Media',
          //   path: PATH_DASHBOARD.marketing.socialmedia,
          // },
        ],
      },

      {
        title: 'Warranty',
        path: '',
        children: [
          {
            title: 'Warranty Claim & Registration',
            path: PATH_DASHBOARD.warranty.warrantyregistration,
          },
          {
            title: 'Warranty Claim Tracker',
            path: PATH_DASHBOARD.warranty.warrantytracker,
          },
          {
            title: 'Warranty Transfer Form',
            path: PATH_DASHBOARD.warranty.warrantytransfer,
          },
          {
            title: 'Written Warranty',
            path: PATH_DASHBOARD.warranty.writtenwarranty,
          },
          {
            title: 'Warranty Procedure',
            path: PATH_DASHBOARD.warranty.warrantyprocedure,
          },
          {
            title: 'Paper Warranty Claim Form',
            path: PATH_DASHBOARD.warranty.paperwarrantyclaimform,
          },
        ],
      },
      {
        title: 'Training',
        path: '',
        children: [
          {
            title: 'Training Seminars',
            path: PATH_DASHBOARD.training.trainingday,
          },
          {
            title: 'Avalon Product Training',
            path: PATH_DASHBOARD.training.avalonproducttraining,
          },
          {
            title: 'Tahoe Product Training',
            path: PATH_DASHBOARD.training.tahoeproducttraining,
          },
          {
            title: 'Avalon Model Comparison',
            path: PATH_DASHBOARD.training.avalonmodelcomparison,
          },
          {
            title: 'Tahoe Model Comparison',
            path: PATH_DASHBOARD.training.tahoemodelcomparison,
          },
          {
            title: 'Avalon Waketoon Training',
            path: PATH_DASHBOARD.training.avalonwaketoontraining,
          },
          {
            title: 'Tahoe Waketoon Training',
            path: PATH_DASHBOARD.training.tahoewaketoontraining,
          },
          {
            title: 'Damaged Engine Process',
            path: PATH_DASHBOARD.training.damagedengineprocess,
          },
        ],
      },
      {
        title: 'Paper Forms',
        path: '',
        children: [
          {
            title: 'Co-Op Claim Form',
            path: PATH_DASHBOARD.paperforms.coopclaimform,
          },
          {
            title: 'New Advisor Checklist',
            path: PATH_DASHBOARD.paperforms.newadvisorchecklist,
          },
          {
            title: 'Quick Order Form',
            path: PATH_DASHBOARD.paperforms.quickorderform,
          },
          // {
          //   title: 'Return Goods Form',
          //   path: PATH_DASHBOARD.paperforms.returngoodsform,
          // },
          {
            title: 'MSO Request',
            path: PATH_DASHBOARD.paperforms.msorequest,
          },
        ],
      },
      {
        title: 'Inventory',
        path: '',
        children: [
          { title: 'Boat Inventory', path: PATH_DASHBOARD.inventory.boatinventory },
          { title: 'Stock Boat', path: PATH_DASHBOARD.inventory.stockboat },
        ],
      },
      {
        title: 'Customer Service',
        path: '',
        children: [
          {
            title: 'Service Order Tracking',
            path: PATH_DASHBOARD.customerservice.serviceorderstatus,
          },
          {
            title: 'Part Lookup By Boat',
            path: PATH_DASHBOARD.customerservice.partlookupboatentry,
          },
          {
            title: 'Inspection Picture Lookup By Boat',
            path: PATH_DASHBOARD.customerservice.inspectionpicturelookup,
          },

          { title: 'RMA Home', path: PATH_DASHBOARD.customerservice.rmahome },
          {
            title: 'Service Parts Pricing',
            path: PATH_DASHBOARD.customerservice.servicepartspricing,
          },
          {
            title: 'Regional Map',
            path: PATH_DASHBOARD.customerservice.regionalmap,
          },

          // { title: 'Score Card', path: PATH_DASHBOARD.customerservice.scorecard },
        ],
      },
      {
        title: 'Maintenance Portal',
        path: PATH_DASHBOARD.maintenanceportal.technicalinformation,
        target: '_blank',
        icon: <ArrowOutwardIcon />,
      },
    ],
  },
];

export default navConfig;
